// UI labels for properties whose DB name differs from what should be displayed
const PROPERTY_LABELS: Record<string, string> = {
  BadmintonScoringSystem: 'Scoring System',
};

// UsesTBDTeams
export const normalizeProperty = (property: string): string => {
  if (PROPERTY_LABELS[property]) {
    return PROPERTY_LABELS[property];
  }

  let splitedWordsProperty = property.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  if (splitedWordsProperty.includes('.') || splitedWordsProperty.includes('_')) {
    splitedWordsProperty = splitedWordsProperty.replace(/\./g, ' ');
    splitedWordsProperty = splitedWordsProperty.replace(/_/g, ' ');
  }
  const capitalizedFirstLetterProperty =
    splitedWordsProperty.charAt(0).toUpperCase() + splitedWordsProperty.slice(1);

  return capitalizedFirstLetterProperty;
};

export const isValidUrl = url => {
  const pattern = /((https?:\/\/)?([-\w]+\.)?[-\w]+(\.\w+)+([/?=&#]\S*)?)/gi;
  return !!pattern.test(url);
};
